import * as React from 'react'

import { Select, SelectOption } from '../../../components'
import { ScaleLabel, ScaleType } from '../../../constants/common'
import { useForceUpdate } from '../../../utils/force-update'
import { useChartLayoutGlobalModel } from '../chart-layout-model'
import { handleScaleChange } from './model-manipulation'

interface IChartScale {
  value: ScaleType
  label: string
}

const DEFAULT_SCALES: IChartScale[] = [
  { value: ScaleType.Linear, label: ScaleLabel[ScaleType.Linear] },
  { value: ScaleType.Percentage, label: ScaleLabel[ScaleType.Percentage] },
  { value: ScaleType.Logarithmic, label: ScaleLabel[ScaleType.Logarithmic] },
]

export function ChartScaleSelect() {
  const { forceUpdate } = useForceUpdate()
  const { chartLayoutModel } = useChartLayoutGlobalModel()

  const onScaleChange = React.useCallback(
    (scale: ScaleType) => {
      if (chartLayoutModel) {
        handleScaleChange({ scale, chartLayoutModel })
        forceUpdate()
      }
    },
    [chartLayoutModel, forceUpdate]
  )

  if (!chartLayoutModel) return null

  return (
    <Select
      data-testid="chart-scale-select"
      aria-label="Chart scale"
      label="Chart scale"
      onChange={(item: IChartScale) => {
        onScaleChange(item.value)
      }}
      value={chartLayoutModel?.charts().first()?.scale}
      items={DEFAULT_SCALES}
      className="w-full"
      size="medium"
    >
      {DEFAULT_SCALES.map((item) => (
        <SelectOption data-testid={`chart-scale-select-${item.value}`} key={item.value}>
          {item.label}
        </SelectOption>
      ))}
    </Select>
  )
}
